// src/components/FireworksBackground.tsx
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { Fireworks, type FireworksOptions } from "fireworks-js";

type Props = {
  enabled?: boolean;
  zIndex?: number;
  options?: Partial<FireworksOptions>;
};

const FireworksBackground: React.FC<Props> = ({
  enabled = true,
  zIndex = 1,
  options,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const fwRef = useRef<Fireworks | null>(null);

  useEffect(() => {
    if (!enabled || !containerRef.current) return;

    const defaults: FireworksOptions = {
        rocketsPoint: { min: 0, max: 15 }, // lewy bok
        hue: { min: 0, max: 360 },
      
        // 🔹 dużo wolniej (rzadziej startują)
        delay: { min: 30, max: 60 },
      
        // 🔹 wolniejszy dolot rakiety (wyraźniej widać trajektorię)
        traceSpeed: 2.2,
        traceLength: 6,
        acceleration: 1.02,
        friction: 0.97,
      
        // 🔹 iskry po wybuchu opadają spokojniej
        gravity: 1.3,
      
        // 🔹 mniejszy, „bliższy” wybuch (krótszy zasięg)
        particles: 50,
        explosion: 4,
      
        // (opcjonalnie, dla lepszej czytelności)
        brightness: { min: 55, max: 85 },
        decay: { min: 0.006, max: 0.012 },
        flickering: 35,
        intensity: 22, // nie schodź niżej ~18, bo bywa „cisza”
      
        autoresize: true,
        opacity: 0.55,
        sound: { enabled: false },
    };
      

    fwRef.current = new Fireworks(containerRef.current, {
      ...defaults,
      ...(options ?? {}),
    });

    fwRef.current.start();

    return () => {
      fwRef.current?.stop(true);
      fwRef.current = null;
    };
  }, [enabled]); // nie dodajemy `options`, żeby nie resetował się co render

  return <CanvasLayer ref={containerRef} style={{ zIndex }} />;
};

export default React.memo(FireworksBackground);

const CanvasLayer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;
